export default __webpack_public_path__ + "static/media/materialdesignicons-webfont.cf402089.woff2";